import React from 'react';
import { Link } from 'react-router-dom';
import {
	SkeletonBannerWrapper,
	SkeletonBulletinWrapper,
	SkeletonHomeArticle,
	SkeletonHomeWrapper,
	SkeletonListWrapper,
	SkeletonMoBannerWrapper,
	SkeletonMoRecentWrapper,
	SkeletonMoRightWrapper,
	SkeletonPocketWrapper,
	SkeletonRecentWrapper,
	SkeletonRightWrapper,
	SkeletonSerieWrapper,
	SkeletonSeriesWrapper,
	SkeletonSingleWrapper,
	SkeletonTagWrapper,
	SkeletonTopWrapper,
	SkeletonWritertWrapper,
} from './styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const dummy = [
	{
		banner: '',
	},
	{
		banner: '',
	},
	{
		banner: '',
	},
];

const series = [
	{
		banner: '',
	},
	{
		banner: '',
	},
	{
		banner: '',
	},
];

// 메인페이지
export const SkeletonHome = () => {
	return (
		<SkeletonHomeWrapper>
			<div className="main-wrapper">
				<Swiper
					modules={[Navigation, Pagination, Scrollbar, A11y]}
					spaceBetween={20}
					slidesPerView={1}
					navigation={{
						prevEl: '.swiper-button-prev',
						nextEl: '.swiper-button-next',
					}}
					pagination={{ clickable: true }}
					onSwiper={(swiper) => console.log(swiper)}
					onSlideChange={() => console.log('slide change')}
				>
					{dummy.map((item, key) => (
						<SwiperSlide kry={key}>
							<div className="flex">
								<div className="left-box">
									<p></p>
									<h2></h2>
									<div className="more-btn">자세히 보기</div>
								</div>
								<div className="right-box">
									<div>
										<div className="banner"></div>
									</div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
			</div>
		</SkeletonHomeWrapper>
	);
};
export const SkeletonHomeArt = () => {
	return (
		<SkeletonHomeArticle>
			<div className="article-wrap">
				<div className="left-box">
					<div className="card-box">
						<div className="article-card">
							<div className="article-img"></div>
							<div className="text-box">
								<div className="tag-box">
									<p className="cate"></p>
								</div>
								<h3></h3>
								<p className="content"></p>
								<div className="flex"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</SkeletonHomeArticle>
	);
};
export const SkeletonHomePocket = () => {
	return (
		<SkeletonHomeArticle>
			<div className="article-wrap">
				<div className="right-box">
					<div className="shapes-box"></div>
				</div>
			</div>
		</SkeletonHomeArticle>
	);
};

export const SkeletonSeriess = () => {
	return (
		<SkeletonSeriesWrapper>
			<div className="series-wrap">
				<Swiper
					spaceBetween={10}
					slidesPerView={1}
					centeredSlides={true}
					loop={true}
					onSlideChange={() => console.log('slide change')}
					onSwiper={(swiper) => console.log(swiper)}
				>
					{series.map((item, key) => (
						<SwiperSlide key={key}>
							<div className="banner">
								<p className="title"></p>
								<p className="total"></p>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</SkeletonSeriesWrapper>
	);
};

// 리스트
export const SkeletonList = () => {
	return (
		<SkeletonListWrapper>
			<div className="flex-wrapper">
				<div className="left">
					<div className="article-wrap">
						<div className="flex-wrap">
							<div className="left-box">
								<div className="card-box">
									<div className="article-card">
										<div className="cardimgbox">
											<div className="article-img"></div>
										</div>
										<div className="text-box">
											<div className="tag-box"></div>
											<h3></h3>
											<p className="content"></p>
											<div className="flex"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</SkeletonListWrapper>
	);
};
export const SkeletonListRight = () => {
	return (
		<SkeletonRightWrapper>
			<div className="right">
				<div className="top-box">
					<div className="topimgs"></div>
					<div className="text-box">
						<h3></h3>
						<p></p>
					</div>
				</div>
				<div className="content"></div>
				<div className="series">
					<h3>추천 포켓</h3>
					<div className="series-list">
						<div className="list">
							<div>
								<div className="seriesimg"></div>
							</div>
							<div className="text-box">
								<h4></h4>
								<p></p>
							</div>
						</div>
						<div className="list">
							<div>
								<div className="seriesimg"></div>
							</div>
							<div className="text-box">
								<h4></h4>
								<p></p>
							</div>
						</div>
						<div className="list">
							<div>
								<div className="seriesimg"></div>
							</div>
							<div className="text-box">
								<h4></h4>
								<p></p>
							</div>
						</div>
					</div>
				</div>
				<div className="tag">
					<h3>최근 가장 인기있는 태그</h3>
					<ul></ul>
				</div>
			</div>
		</SkeletonRightWrapper>
	);
};
export const SkeletonMoRight = () => {
	return (
		<SkeletonMoRightWrapper>
			<div className="mo-top-box">
				<div>
					<div className="topimg"></div>
				</div>
				<div className="text-box">
					<h3></h3>
					<p></p>
				</div>
			</div>
			<div className="mo-content" style={{ height: '120px' }}></div>
		</SkeletonMoRightWrapper>
	);
};
export const SkeletonBanner = () => {
	return (
		<SkeletonBannerWrapper>
			<div className="banner"></div>
		</SkeletonBannerWrapper>
	);
};
export const SkeletonMoBanner = () => {
	return (
		<SkeletonMoBannerWrapper>
			<div className="banner"></div>
		</SkeletonMoBannerWrapper>
	);
};
export const SkeletonSeriesWrap = () => {
	return (
		<SkeletonSerieWrapper>
			<div className="right">
				<div className="series">
					<h3>추천 포켓</h3>
					<div className="series-list">
						<div className="list">
							<div>
								<div className="seriesimg"></div>
							</div>
							<div className="text-box">
								<h4></h4>
								<p></p>
							</div>
						</div>
					</div>
				</div>
				<div className="tag">
					<h3>최근 가장 인기있는 태그</h3>
					<ul></ul>
				</div>
			</div>
		</SkeletonSerieWrapper>
	);
};

// 싱글
export const SkeletonSingle = () => {
	return (
		<SkeletonSingleWrapper>
			<div className="article-wrap">
				<div className="tag-box"></div>
				<h2 className="title"></h2>
				<div className="share-box">
					<div className="left">
						<a>
							<img src="/images/icon-kakao.svg" alt="" />
						</a>
						<a>
							<img src="/images/icon-share.svg" alt="" />
						</a>
					</div>
					<div className="right"></div>
				</div>
				<div className="flex-wrap">
					<div className="left-box">
						<div className="article-box">
							<div className="article"></div>
							<div className="content"></div>
						</div>
						<div className="mo-top-wrap">
							<div className="mo-top-box">
								<div className="imgbox">
									<div className="topimg"></div>
								</div>
								<div className="text-box">
									<h3></h3>
									<p></p>
								</div>
							</div>
							<div className="mo-content" style={{ height: '81px' }}></div>
						</div>
						<div className="list-btn-box">
							<Link className="list-btn">
								<img src="/images/icon-back01.svg" alt="" />
								목록으로
							</Link>
						</div>
					</div>
				</div>
			</div>
		</SkeletonSingleWrapper>
	);
};
export const SkeletonBulletin = () => {
	return (
		<SkeletonBulletinWrapper>
			<div className="bulletin-list">
				<div className="photo-box">
					<div className="photo"></div>
				</div>
				<div className="text-box">
					<ul></ul>
					<h4></h4>
					<div className="date-box"></div>
				</div>
			</div>
			<div className="bulletin-list">
				<div className="photo-box">
					<div className="photo"></div>
				</div>
				<div className="text-box">
					<ul></ul>
					<h4></h4>
					<div className="date-box"></div>
				</div>
			</div>
			<div className="bulletin-list">
				<div className="photo-box">
					<div className="photo"></div>
				</div>
				<div className="text-box">
					<ul></ul>
					<h4></h4>
					<div className="date-box"></div>
				</div>
			</div>
		</SkeletonBulletinWrapper>
	);
};
export const SkeletonRecent = () => {
	return (
		<SkeletonRecentWrapper>
			<div className="article-wrap">
				<div className="card">
					<div className="banner"></div>
					<div className="content">
						<ul></ul>
						<h2 className="title"></h2>
						<p className="cont"></p>
						<div className="flex"></div>
					</div>
				</div>
				<div className="card">
					<div className="banner"></div>
					<div className="content">
						<ul></ul>
						<h2 className="title"></h2>
						<p className="cont"></p>
						<div className="flex"></div>
					</div>
				</div>
				<div className="card">
					<div className="banner"></div>
					<div className="content">
						<ul></ul>
						<h2 className="title"></h2>
						<p className="cont"></p>
						<div className="flex"></div>
					</div>
				</div>
			</div>
		</SkeletonRecentWrapper>
	);
};
export const SkeletonMoRecent = () => {
	return (
		<SkeletonMoRecentWrapper>
			<div className="article-wrap">
				<Swiper
					spaceBetween={10}
					slidesPerView={1.06}
					onSlideChange={() => console.log('slide change')}
					onSwiper={(swiper) => console.log(swiper)}
				>
					{dummy.map((item, key) => (
						<SwiperSlide>
							<div className="card">
								<div className="banner"></div>
								<div className="content-box">
									<ul></ul>
									<h2 className="title"></h2>
									<p className="cont"></p>
									<div className="flex"></div>
								</div>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
		</SkeletonMoRecentWrapper>
	);
};

// 작성
export const SkeletonWriter = () => {
	return (
		<SkeletonWritertWrapper>
			<div className="writer">
				<div className="writer-user-box">
					<div className="bg"></div>
					<div className="user-flex">
						<div className="user-left">
							<div className="user-img">
								<div className="user"></div>
							</div>
							<div className="user-name">
								<h3></h3>
								<p></p>
							</div>
						</div>
						<div className="user-right"></div>
					</div>
				</div>
				<div className="under-article">
					<div className="article-left">
						<h2></h2>
						<p></p>
					</div>
					<div className="mo-article-left">
						<div className="flex">
							<h2></h2>
						</div>
						<div className="mo-right"></div>
					</div>
					<div className="article-right">
						<p className="cont"></p>
					</div>
				</div>
			</div>
		</SkeletonWritertWrapper>
	);
};

// 포켓
export const SkeletonPocket = () => {
	return (
		<SkeletonPocketWrapper>
			<div className="pocket-wrap">
				<div className="pocket-list">
					<>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
						<div className="mo-pocket"></div>
					</>
				</div>
			</div>
		</SkeletonPocketWrapper>
	);
};

//오른쪽메뉴
export const SkeletonRightTop = () => {
	return (
		<SkeletonTopWrapper>
			<div className="top-box">
				<div className="imgbox">
					<div className="topimg"></div>
				</div>
				<div className="text-box">
					<h3></h3>
					<p className="total"></p>
				</div>
			</div>
			<div className="content"></div>
		</SkeletonTopWrapper>
	);
};
export const SkeletonRightTag = () => {
	return (
		<SkeletonTagWrapper>
			<ul></ul>
		</SkeletonTagWrapper>
	);
};
